import React, { PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
import Log from "./Log";
import { FormActions, FormBody, SelectInput, TextInput } from "../../../Form";
import Form from "../../../Form";
import { token } from '../../../../libs/localStorage';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import { BASE_URL } from '../../../../config';
import moment from "moment/moment";
import _ from 'lodash';
import Button from '../../../Form/Button';

@inject('workOrderStore', 'userStore', 'inventoryItemStore', 'inventoryProductStore', 'ticketStore')
@observer
export default class WorkOrderLogRoot extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  }

  @observable logNote = false;
  @observable log = {
    user_id: +token.getDecoded().id,
    item_id: null,
    assigned_to: null,
    log_date: null,
    message: {
      text: ''
    },
    actual_man_hours: null
  };
  @observable attachment_file = null;
  @observable isLoading = false;

  @action onToggleLogNote = e => this.logNote = !this.logNote;
  @action onChangeLogMessage = e => this.log.message.text = e.target.value;
  @action onChangeItem = e => this.log.item_id = e.target.value;
  @action onChangeAssignedTo = e => this.log.assigned_to = e.target.value;
  @action onChangeManHours = e => this.log.actual_man_hours = e.target.value;

  onOpenClick = () => this.refs.dropzone.open();

  componentWillMount() {
    const { workOrderStore, inventoryItemStore, inventoryProductStore } = this.props;
    inventoryItemStore.items.length === 0 && inventoryItemStore.fetchItems();
    inventoryProductStore.items.length === 0 && inventoryProductStore.fetchItems();
  }

  onDrop = files => this.attachment_file = files[0];

  onLogNote = e => {
    e.preventDefault();
    const { workOrderStore, userStore, workOrder_id } = this.props;
    const { notify } = this.context;
    const url = `${BASE_URL}/mms/work_order/${workOrder_id}/log`;
    this.isLoading = true;

    let log = Object.assign({}, toJS(this.log)), sender = token.getDecoded();
    log.log_date = new Date();
    log.followers = workOrderStore.getCheckedFollowers.map(follower => follower.email);
    log.sender = { name: sender.name, email: sender.email };
    log.email = {
      subject: `Work Order ${workOrder_id}`,
      link: window.location.href
    };

    const req = request
      .post(url)
      .set('Authorization', `Bearer ${token.getEncoded()}`);

    if (this.attachment_file) req.field('data', JSON.stringify(log)).attach('file', this.attachment_file);
    else req.set('content-type', 'application/json').send(log);

    req.end((err, res) => {
      this.isLoading = false;
      if (err) console.error(err);
      else {
        const user = token.getDecoded();
        this.log = {
          user_id: +user.id,
          item_id: null,
          assigned_to: null,
          log_date: null,
          message: {
            text: ''
          }
        };
        this.attachment_file = null;
        this.props.workOrderStore.pushLog(Object.assign({}, log, { name: user.name, email: user.email }), res.body.src);
        this.onToggleLogNote();
        notify.success({ message: 'Log added' });
        if (res.body.mail) notify.success({ message: 'Email sent' });
        else notify.error({ message: 'Email not sent' });
      }
    })

  };

  renderLogInputArea = () => {
    const { inventoryItemStore, inventoryProductStore, userStore } = this.props;
    let inventoryItems = inventoryItemStore.items.map(item => {
      return {
        id: item.id,
        name: `${inventoryProductStore.findById(item.product_id).pcategory_name} - ${item.serial_no}`
      }
    });

    return (
      <div className={'bordered indented-form'} style={{ padding: '20px', margin: 0 }}>
        <Form>
          <FormBody>
            <div className='formInput flex fill-parent'>
              <textarea value={this.log.message.text} onChange={this.onChangeLogMessage} placeholder='Write something...' />
            </div>
            <br />
            <div className='inline-grid space-between v-center'>
              <div>
                <SelectInput label='Assigned To' options={userStore.items} fields={{ value: 'id', label: 'name' }} value={this.log.assigned_to} onChange={this.onChangeAssignedTo} />
                <SelectInput label='Item' options={inventoryItems} fields={{ value: 'id', label: 'name' }} value={this.log.item_id} onChange={this.onChangeItem} />
                <TextInput value={this.log.actual_man_hours} label='Actual Man Hours' onChange={this.onChangeManHours} />
              </div>
              <ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }} />
              {this.attachment_file ?
                <div>
                  {this.attachment_file.name}
                  <span className='fa fa-remove' onClick={() => this.attachment_file = null} />
                </div> :
                <span data-toggle="tooltip" title='Attach file' className='fa fa-paperclip align-v' onClick={this.onOpenClick} />}
            </div>
          </FormBody>
          <FormActions>
            <button className='button' onClick={this.onToggleLogNote}>Cancel</button>
            <Button label='Save' onClick={this.onLogNote} isLoading={this.isLoading} />
          </FormActions>
        </Form>
      </div>
    )
  };

  render() {
    const { workOrderStore, inventoryItemStore } = this.props;

    let groupedLogs = workOrderStore.workOrder_logs ? _.groupBy(workOrderStore.workOrder_logs, item => moment(item.log_date).format('YYYY-MM-DD')) : null;
    return (
      <div className='full-width'>
        {!this.logNote && <button className={'button button-inactive'} onClick={this.onToggleLogNote}>{'Log note'}</button>}
        {this.logNote && this.renderLogInputArea()}<br />

        {groupedLogs && <div className='logs-container'>{Object.keys(groupedLogs).sort((a, b) => (new Date(a)).valueOf() < (new Date(b)).valueOf() ? 1 : -1).map(key => <Log key={`workOrder_log_${key}`} date={key} logs={groupedLogs[key]} />)}</div>}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Log/WorkOrderLogRoot.js